export class LoginRequest {
  token: string;
  clientType = 1;

  constructor(token: string) {
    this.token = token;
  }
}

export const enum ListenerType {
    Listener_UserTasks = 1,
    Listener_TaskUpdated = 2,
    Listener_TaskAdded = 3,
    Listener_TaskDeleted = 4,
    Listener_TaskChecklistTemplate = 5,
    Listener_TaskIndividual = 6,
    Listener_DelegatedTasks = 7,
    Listener_TaskColumnReordered = 8
}

export const enum MessageAction {
    ADD = 1,
    REMOVE = 2,
    REMOVE_ADD = 3
}

export class ListenerRequestMessage {
  action: MessageAction;
  type: ListenerType;
  query: any;

  constructor (action: MessageAction, type: ListenerType, query?: any) {
    this.action = action;
    this.type = type;
    this.query = query;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/socket/socketInterfaces.ts